<template>
    <div class="container-xxl">
        <div class="row justify-content-center pt-5 overflow-hidden">
            <div class="col-12 col-xxl-8">
                <div class="swiper-team">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(slide, index) in team"
                            :key="'swiper-slide-' + index"
                            class="swiper-slide"
                        >
                            <img :src="slide.imageMobile.url" :alt="slide.imageMobile.title" />
                        </div>
                    </div>

                    <div class="swiper-pagination"></div>

                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
            </div>

            <div class="col-12 col-xxl-4 col-swiper-news-description">
                <div class="swiper-team-description">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(slide, index) in team"
                            :key="'swiper-slide-credit-' + index"
                            class="swiper-slide"
                        >
                            <div class="img-description" v-html="slide.text"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle.js'

// import styles bundle
import 'swiper/swiper-bundle.min.css'

export default {
    name: 'SwiperTeam',
    components: {},
    props: {
        team: {
            type: Array,
            required: true,
        },
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data

                    setTimeout(function () {
                        const swiper_news_desc = new Swiper('.swiper-team-description', {
                            // Optional parameters
                            loop: true,
                            effect: 'fade',
                            grabCursor: false,
                            allowSlideNext: false,
                            allowSlidePrev: false,
                        })

                        new Swiper('.swiper-team', {
                            // Optional parameters
                            loop: true,
                            autoHeight: true,
                            // If we need pagination
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'fraction',
                            },
                            // Navigation arrows
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                            controller: {
                                control: swiper_news_desc,
                            },
                        })
                    }, 2000)
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },
}
</script>
